// extracted by mini-css-extract-plugin
export default {"choiceWrapper":"ChoiceItem_choiceWrapper__fyarc","customizedScroll":"ChoiceItem_customizedScroll__3dvbU"};